<template>
  <div>
   <el-dialog title="申请开票" :visible="SQkaiPiaoMark" :close-on-click-modal="false" @close="closeDialog" width="500px" center >
      <div class="addressBox">
        <div style="width:80%;margin:0 auto;">
          <el-form :inline="true" :model="kaiPiaoFrom" label-position="left" ref="kaiPiaoFrom" class="demo-form-inline"  size="small">
            <div style=" display: flex;justify-content: space-between;">
               <el-form-item label="运单收入总额:">
                  <span style="color:red;font-size:18px;margin-right:5px;">{{kaiPiaoFrom.revenueAmount }}</span><span>元</span>
                </el-form-item>
                <el-form-item label="申请开票运单:">
                  <span style="color:red;font-size:18px;margin-right:5px;">{{kaiPiaoFrom.wayNumber}}</span><span>单</span>
                </el-form-item>
            </div>
            <el-form-item label="申请开票金额:" class="jiage">
              <!-- <el-input maxlength="10" v-model.trim="kaiPiaoFrom.pendingAmount" v-number-input.float="2" style="width:240px;"></el-input>
              <span  class="danwei">元</span> -->
               <span style="color:red;font-size:18px;margin-right:5px;">{{kaiPiaoFrom.pendingAmount }}</span><span>元</span>
            </el-form-item>
            <el-form-item label="备注:" prop="remark" >
              <el-input placeholder="" type="textarea" maxlength="50" v-model="kaiPiaoFrom.remark" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="附件:" v-if="SQkaiPiaoMark" >
              <uploadFiles style="width:300px;" :fileArr.sync='imgList' :max='10' v-if="SQkaiPiaoMark"></uploadFiles>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary"  @click="sqkpSaveFn">确定申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { invoiceApplyForYsBillList, invoiceApplyCheckForYsBillList, invoiceApplyCheckForYsWayList,
  invoiceApplyForYsWayList } from '@/api/newTMS'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
export default {
  components: {
    uploadFiles
  },
  props: {
    SQkaiPiaoMark: {
      type: Boolean,
      default: false
    },
    SQkaiPiaoFrom: {
      type: Object,
      default: function () {
        return {}
      }
    },
    detilsFlag: {
      type: Boolean,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      kaiPiaoFrom: this.SQkaiPiaoFrom,
      imgList: [],
      rules: {
        invoiceNo: [
          { required: true, message: '请输入发票号码', trigger: 'blur' }
        ],
        invoiceTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    console.log(this.detilsFlag)
    if (this.detilsFlag) {
      invoiceApplyCheckForYsWayList({ billId: this.kaiPiaoFrom.billId, ids: this.kaiPiaoFrom.ids }).then(res => {
        this.$set(this.kaiPiaoFrom, 'pendingAmount', res.pendingAmount)
        this.$set(this.kaiPiaoFrom, 'revenueAmount', res.pendingAmount)
        this.kaiPiaoFrom.wayNumber = res.wayNumber
        this.kaiPiaoFrom.payer = res.payer
        this.SQkaiPiaoMark = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    } else {
      invoiceApplyCheckForYsBillList({ ids: this.kaiPiaoFrom.ids }).then(res => {
        this.$set(this.kaiPiaoFrom, 'pendingAmount', res.pendingAmount)
        this.$set(this.kaiPiaoFrom, 'revenueAmount', res.pendingAmount)
        this.kaiPiaoFrom.wayNumber = res.wayNumber
        this.kaiPiaoFrom.payer = res.payer
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    }
  },
  methods: {
    // 账单页面
    sqkpSaveFn () {
      let imgfile = new FormData()
      imgfile.set('params', JSON.stringify(this.kaiPiaoFrom))
      this.imgList.forEach(item => {
        imgfile.append('files', item.raw)
      })
      if (this.detilsFlag) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceApplyForYsWayList(imgfile).then(res => {
          loading.close()
          this.$message({
            message: '申请成功',
            type: 'success'
          })
          this.$parent.getList()
          this.$emit('update:SQkaiPiaoMark', false)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceApplyForYsBillList(imgfile).then(res => {
          loading.close()
          this.$message({
            message: '申请成功',
            type: 'success'
          })
          this.$parent.getList()
          this.$emit('update:SQkaiPiaoMark', false)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    closeDialog () {
      this.$emit('update:SQkaiPiaoMark', false)
    }
  }
}
</script>
<style scoped>
.imgBoxS{
  width: 260px!important;
}
</style>
